<template>
  <document-container
      :body="template.body()"
      :footer="template.footer()"
      :header="template.header()"
      :logo="logo"
      :tables="tables"
      documentType="onepager"
  >

    <div
        v-for="block in template.body()"
        slot="raw-body"
        :class="block.type !== 'Pagebreak' ? 'page-block' : ''">

      <component
          :is="block.type"
          v-if="block.type!=='ProductTable'"
          :data="block"
      ></component>

      <product-table
          v-if="block.type === 'ProductTable'"
          id="product-table"
          :table="tables.findTable('product-table')"
      ></product-table>

    </div>

    <div v-if="template.config.longDisclaimer && template.config.longDisclaimer.body.length > 0" slot="raw-body"
         class=" page-block">

      <textblock
          :data="template.config.longDisclaimer"
      ></textblock>
    </div>
  </document-container>
</template>

<script>
import DocumentContainer
  from '../document/DocumentContainer'
import BlockMixin
  from '../block/BlockMixin'
import ProductTable
  from '../table/TableOnepagerProducts.vue'
import {
  Table,
} from '../../model/table/Table'
import {
  TableCollection,
} from '../../model/table/TableCollection'

export default {
  name: 'onepager',

  data() {
    return {
      ProductTable,
      tables: {
        type: TableCollection,
      },
    }
  },

  mixins: [BlockMixin],

  props: {
    environment: {
      type: String,
      required: true,
    },
    products: {
      type: Array,
      required: true,
    },
    tableConfig: {
      type: Array,
      required: true,
    },
    template: {
      type: Object,
      required: true,
    },
    multiRowPath: {
      type: String,
      required: false,
    },
    logo: {
      type: String,
      required: true,
    },
  },


  created() {
    this.tables = new TableCollection(
        new Table(
            'product-table',
            this.tableConfig,
            this.products,
            ProductTable,
            null,
            this.multiRowPath,
            this.environment === 'hauck',
        ),
    )
  },

  components: {
    DocumentContainer,
    ProductTable,
  },
}
</script>



// WEBPACK FOOTER //
// Onepager.vue?2334859a